import useSWR from "swr";

import { fetcher } from "@zapier/trials/src/utils/fetcher";
import { ActionsResponse } from "@zapier/trials/src/types";

type Props = {
  builderApiKey: string;
};

export const useTrialActions = ({ builderApiKey }: Props) => {
  const { data, error, isLoading } = useSWR<ActionsResponse>(
    `https://cdn.builder.io/api/v3/content/trial-hub-actions?apiKey=${builderApiKey}&limit=5&cacheSeconds=60`,
    fetcher
  );

  const actions = (data?.results || []).map((result) => result.data);

  return {
    isLoading,
    error,
    actions,
  };
};
